import { render, staticRenderFns } from "./EditPages.vue?vue&type=template&id=ca0c43aa"
import script from "./EditPages.vue?vue&type=script&lang=js"
export * from "./EditPages.vue?vue&type=script&lang=js"
import style0 from "./EditPages.vue?vue&type=style&index=0&id=ca0c43aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports